import React from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { MultiStateCheckbox } from 'primereact/multistatecheckbox';
import { dictionary } from '../../../dictionary';

const InvoiceFooter = ({ comment, setComment, handleSaveInvoice, setInvoiceStatus, invoiceStatus, options }) => {
  const handleStatusChange = (e) => {
    const newValue = e.value;
    if (newValue === null || newValue === undefined) {
      setInvoiceStatus(options[0].value);
    } else {
      setInvoiceStatus(newValue);
    }
  };

  const handleWithdrawn = () => {
    handleSaveInvoice('withdrawn');
  };

  return (
    <>
      <div className="field-col">
        <label>{dictionary.esp_dialog_invoice_check_status}</label>
        <div className="checkbox-wrapper">
            <MultiStateCheckbox
              value={invoiceStatus}
              onChange={handleStatusChange}
              options={options}
              optionValue="value"
              optionclassname="className"
            />
            <span>{invoiceStatus}</span>
        </div>
      </div>
      <div className="field-col">
        <label>{dictionary.esp_dialog_invoice_comments}</label>
        <InputText
          style={{ width: '100%' }}
          placeholder={dictionary.dialog_placeholder_comment}
          value={comment !== null ? comment : ''}
          onChange={(e) => {
            setComment(e.target.value);
          }}
        />
      </div>
      <div className="field-row">
        <div className="col" style={{ marginRight: '0.5rem' }}>
          <Button
            label={dictionary.esp_dialog_invoice_withdrawn}
            icon="pi pi-times-circle"
            className="field-report-btn withdrawn-btn"
            onClick={handleWithdrawn}
          />
        </div>
        <div className="col">
          <Button
            label={dictionary.esp_dialog_invoice_completed}
            icon="pi pi-save"
            className="field-report-btn"
            onClick={() => handleSaveInvoice()}
          />
        </div>
      </div>
    </>
  );
};

export default InvoiceFooter;